import { Alert } from '@/components/alert';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import { FormattedMessage, useIntl } from '@/components/formatted_message/FormattedMessage';
import { Typography } from '@/components/typography';
import { useAuthContext } from '@/contexts/AuthContext';
import { EnmonLogo } from '@/routes/auth/components/EnmonLogo';
import { StyledAuthLayout } from '@/routes/auth/components/Containers';
import { StyledFormWrapper } from '@/routes/auth/components/FormContainer';
import { Flex } from 'antd';
import { Helmet } from 'react-helmet';
import { Page as messages } from './messages';

const { Headline, Paragraph } = Typography;

export const ConsentPage = () => {
  const intl = useIntl();
  const {
    approveOAuthConsentAsync,
    error: { oauthConsent },
    loading: { isLoadingOAuthConsent },
  } = useAuthContext();

  const handleContinue = async () => {
    try {
      const data = await approveOAuthConsentAsync(window.location.search.slice(1));
      if (data?.url) {
        window.location.assign(data.url);
      }
    } catch {
      // Error state is handled by the auth mutation and rendered below.
    }
  };

  return (
    <StyledAuthLayout>
      <Helmet>
        <title>{intl.formatMessage(messages.helmet)}</title>
      </Helmet>
      <EnmonLogo />
      <Flex gap={24} vertical>
        <Flex vertical gap={8}>
          <Headline>
            <FormattedMessage {...messages.title} />
          </Headline>
          <Paragraph>
            <FormattedMessage {...messages.description} />
          </Paragraph>
        </Flex>
        {oauthConsent ? (
          <Alert
            description={<FormattedMessage {...messages.error} />}
            showIcon
            style={{ marginBottom: 0 }}
            type="error"
          />
        ) : null}
        <StyledFormWrapper>
          <ButtonAnt type="primary" loading={isLoadingOAuthConsent} onClick={handleContinue}>
            <FormattedMessage {...messages.continue} />
          </ButtonAnt>
        </StyledFormWrapper>
      </Flex>
    </StyledAuthLayout>
  );
};
